// extracted by mini-css-extract-plugin
export var header = "_tp-1";
export var maskBottom = "_tp-6";
export var maskMiddle = "_tp-7";
export var maskTop = "_tp-5";
export var root = "_tp-0";
export var scrollDownButton = "_tp-3";
export var scrollDownButtonHidden = "_tp-4";
export var viewport = "_tp-2";